import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Sticky from "react-stickynode";

const Header = () => {
  const [activeSection, setActiveSection] = useState("");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const searchBtn = document.getElementById("quik-search-btn");
    const searchPopup = document.querySelector(".dlab-quik-search");
    const closeBtn = document.getElementById("quik-search-remove");

    if (searchBtn && searchPopup && closeBtn) {
      searchBtn.addEventListener("click", () => {
        searchPopup.style.display = "block";
        searchPopup.classList.add("On");
      });

      closeBtn.addEventListener("click", () => {
        searchPopup.style.display = "none";
        searchPopup.classList.remove("On");
      });
    }

    const btn = document.querySelector(".navicon");
    const nav = document.querySelector(".header-nav");

    const toggleFunc = () => {
      btn.classList.toggle("open");
      nav.classList.toggle("show");
    };

    if (btn && nav) {
      btn.addEventListener("click", toggleFunc);
    }

    const navUl = Array.from(
      document.querySelectorAll(".header-nav > ul > li")
    );

    const checkLi = (current) => {
      const active = current.classList.contains("open");
      navUl.forEach((el) => el.classList.remove("open"));

      if (active) {
        current.classList.remove("open");
      } else {
        current.classList.add("open");
      }
    };

    navUl.forEach((item) => {
      item.addEventListener("click", () => checkLi(item));
    });

    // Cleanup event listeners on component unmount
    return () => {
      if (searchBtn && closeBtn) {
        searchBtn.removeEventListener("click", () => {});
        closeBtn.removeEventListener("click", () => {});
      }
      if (btn) {
        btn.removeEventListener("click", toggleFunc);
      }
      navUl.forEach((item) => {
        item.removeEventListener("click", () => {});
      });
    };
  }, []);



  useEffect(() => {
    const sectionIds = ["home", "about", "services", "testimonials", "industries"];
    const observers = [];

    sectionIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setActiveSection(id);
              }
            });
          },
          { threshold: 0.5 } // Adjust the threshold as needed
        );
        observer.observe(section);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  const handleNavigation = (sectionId) => {
    setActiveSection(sectionId);

    if (location.pathname !== "/") {
      history.push("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="site-header mo-left header">
      <Sticky innerZ={999} enabled={true}>
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar clearfix ">
            <div className="container clearfix">
              <div className="logo-header mostion">
                <Link to={"/"}>
                  <img src={require("../../images/logo.png")} alt="" />
                </Link>
              </div>

              <button
                className="navbar-toggler navicon justify-content-end"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>

              <div className="extra-nav" style={{ display: "none" }}>
                <div className="extra-cell">
                  <button
                    id="quik-search-btn"
                    type="button"
                    className="site-button-link"
                  >
                    <i className="la la-search"></i>
                  </button>
                </div>
              </div>

              <div className="dlab-quik-search">
                <form action="#">
                  <input
                    name="search"
                    type="text"
                    className="form-control"
                    placeholder="Type to search"
                  />
                  <span id="quik-search-remove">
                    <i className="ti-close"></i>
                  </span>
                </form>
              </div>

              <div
                className="header-nav navbar-collapse collapse justify-content-end"
                id="navbarNavDropdown"
              >
                <div className="logo-header d-md-block d-lg-none">
                  <Link to={"/"}>
                    <img src={require("../../images/logo.png")} alt="" />
                  </Link>
                </div>
                <ul className="nav navbar-nav">
                  <li className={activeSection === "home" ? "active" : ""}>
                    <Link onClick={() => handleNavigation("home")}>Home</Link>
                  </li>
                  <li className={activeSection === "about" ? "active" : ""}>
                    <Link onClick={() => handleNavigation("about")}>About Us</Link>
                  </li>
                  <li className={activeSection === "services" ? "active" : ""}>
                    <Link onClick={() => handleNavigation("services")}>Our Services</Link>
                  </li>
                  {/* <li className={activeSection === "testimonials" ? "active" : ""}>
                    <Link onClick={() => handleNavigation("testimonials")}>Testimonials</Link>
                  </li> */}
                  <li className={activeSection === "industries" ? "active" : ""}>
                    <Link onClick={() => handleNavigation("industries")}>Industries</Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        setActiveSection("contact");
                        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                      }}
                      to="/contact"
                    >
                      Contact Us
                    </Link>
                  </li>
                </ul>
                <div className="dlab-social-icon">
                <ul>
  <li>
    <Link className="site-button circle fab fa-facebook-f" to={"/#"}></Link>
  </li>

  <li>
    <Link className="site-button circle fab fa-instagram" to={"/#"}></Link>
  </li>
  <li>
    <Link className="site-button circle fab fa-youtube" to={"/#"}></Link>
  </li>
</ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Sticky>
    </header>
  );
};

export default Header;
